import { gql } from "graphql-tag"

export default gql`
  fragment Country on Country {
    createdAt
    currencyId
    displayName
    flagEmoji
    flagImageId
    id
    isPublished
    iso2
    iso3
    name
    numeric
    publishedAt
    region
    timezones
    updatedAt
  }
`
